module.exports = __webpack_public_path__ + "img/introduction_size_six@2x.7da82066.png";